/**
 * QA Content Checks Page — Route wrapper for the QAContentChecksPanel.
 */

import { QAContentChecksPanel } from '@/components/qa-content-checks/QAContentChecksPanel';

export default function QAContentChecksPage() {
  return <QAContentChecksPanel />;
}
